import { render, staticRenderFns } from "./generalGoodsInfoConfirm.vue?vue&type=template&id=c336bfa2&scoped=true"
import script from "./generalGoodsInfoConfirm.vue?vue&type=script&lang=js"
export * from "./generalGoodsInfoConfirm.vue?vue&type=script&lang=js"
import style0 from "./generalGoodsInfoConfirm.vue?vue&type=style&index=0&id=c336bfa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c336bfa2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Breadcrumb: require('/drone/src/components/Breadcrumb/index.vue').default,OrderPayDialog: require('/drone/src/components/OrderPayDialog/index.vue').default})
